import { useQuery } from '@tanstack/react-query';
import { Plus } from 'lucide-react';

import { Button } from '@/components/shadcn/ui/button';
import { signalListQueryOptions } from '@/entities/signal';
import useWorkspaceId from '@/hooks/domain/useWorkspaceId';
import { Tooltip } from '@/shared/ui';

const MAX_SIGNAL_COUNT = 5;

export default function SignalAddButton({ onClick }: { onClick: () => void }) {
  const workspaceId = useWorkspaceId();
  const { data } = useQuery(signalListQueryOptions({ workspaceId }));

  if (data && data.length >= MAX_SIGNAL_COUNT) {
    return (
      <Tooltip content="You can create up to 5 signal">
        <Button
          className="text-muted-foreground hover:bg-accent hover:cursor-pointer p-4"
          variant="secondary"
          disabled
        >
          <Plus />
        </Button>
      </Tooltip>
    );
  }

  return (
    <Button
      className="text-muted-foreground hover:bg-accent hover:cursor-pointer p-4"
      variant="secondary"
      onClick={onClick}
    >
      <Plus />
    </Button>
  );
}
